<template>
  <div>
    <b-modal
      size="xl"
      id="media-gallery"
      title="Media Gallery"
      :hide-footer="hideFooter"
    >
      <div class="mb-5">
        <form>
          <h2 class="mb-3">Upload images</h2>
          <div class="form-group custom-file">
            <input
              type="file"
              class="custom-file-input"
              id="file"
              ref="file"
              v-on:change="handleFileUpload()"
            />
            <label v-if="!file.name" class="custom-file-label" for="file"
              >Upload a file</label
            >
            <label v-if="file.name" class="custom-file-label" for="file">{{
              file.name
            }}</label>
          </div>
          <!-- Textarea for custom tags -->
          <div class="form-group">
            <label for="tags">Tags</label>
            <textarea
              class="form-control"
              id="tags"
              rows="3"
              placeholder="Enter tags separated by commas"
              v-model="tags"
            ></textarea>
          </div>
          <div v-if="file.name" class="form-group">
            <button
              class="form-control btn btn-danger"
              v-on:click.prevent="uploadImage()"
            >
              Upload
            </button>
          </div>
        </form>
      </div>

      <hr />

      <h2 class="mb-3 mt-5">Select an image</h2>
      <div class="filter-bar ui basic segment grid">
        <div class="ui form">
          <div class="inline field">
            <label>Search for:</label>
            <input
              type="text"
              v-model="filterText"
              class="three wide column"
              @keyup.enter="doFilter"
              placeholder="name"
            />
            <button class="ui button" @click="resetFilter">Reset</button>
          </div>
        </div>

        <b-pagination
          v-model="page"
          :total-rows="nrOfRows"
          :per-page="perPage"
          first-text="First"
          prev-text="Prev"
          next-text="Next"
          last-text="Last"
          class="ml-auto"
        ></b-pagination>
      </div>

      <div class="grid" ref="grid">
        <masonry
          :cols="{ default: 6, 1400: 6, 1024: 3, 700: 2, 400: 1 }"
          :gutter="{ default: '30px', 700: '15px' }"
        >
          <div
            v-for="image in filteredData"
            :key="image.id"
            class="masonry-item mb-3 border rounded-lg position-relative"
            @click="selectImage(image.name)"
          >
            <!-- <img :src="image.src" :alt="image.alt"> -->
            <img
              class="img-fluid rounded-lg"
              :src="`/media/` + image.name"
              :alt="image.alt"
            />
            <p class="lead font-weight-bold p-2 mb-0 text-truncate">
              {{ image.name }}
            </p>
            <!-- Dimensions WidthXHeight in corner of div -->
            <div
              class="position-absolute"
              style="
                top: 0;
                right: 0;
                background-color: rgba(0, 0, 0, 0.5);
                color: white;
                padding: 5px 10px;
              "
            >
              {{ image.width }}x{{ image.height }}
            </div>
            <!-- <dl class="row px-2 mb-0">
              <dt class="col-6">Width</dt>
              <dd class="col-6 text-right">{{ image.width }}px</dd>
              <dt class="col-6">Height</dt>
              <dd class="col-6 text-right">{{ image.height }}px</dd>
            </dl> -->
          </div>
        </masonry>

        <b-pagination
          v-model="page"
          :total-rows="nrOfRows"
          :per-page="perPage"
          first-text="First"
          prev-text="Prev"
          next-text="Next"
          last-text="Last"
          class="justify-content-center"
        ></b-pagination>
      </div>

      <!-- <vuetable :multi-sort="true" multi-sort-key="ctrl" ref="vuetable" :api-mode="false" :data="filteredData" :fields="fields" pagination-path="" :per-page="perPage" @vuetable:pagination-data="onPaginationData" :append-params="moreParams" :http-options="httpOptions">
        <template slot="src" slot-scope="props">
          <div class="table-button-container text-center">
            <img
              @click="selectImage(props.rowData.name)"
              class="img img-fluid w-50"
              :src="generatePath(props.rowData.name)"
              :alt="props.rowData.name"
            />
          </div>
        </template>
        <template slot="created_at" slot-scope="props">
          <div class="table-button-container text-center">
            {{ formatDate(props.rowData.created_at) }}
          </div>
        </template>
        <template slot="actions" slot-scope="props">
          <div class="table-button-container">
            <button class="btn btn-info mb-2 mr-2" @click="selectImage(props.rowData.name)"><i class="fa fa-plus"></i> Select</button>&nbsp;&nbsp;
            <button class="btn btn-danger mb-2 mr-2" @click="deleteImage(props.rowData.name)"><i class="fa fa-remove"></i> Delete</button>&nbsp;&nbsp;
          </div>
        </template>
      </vuetable>
      <div class="vuetable-pagination ui basic segment grid">
        <vuetable-pagination-info ref="paginationInfo"></vuetable-pagination-info>
        <vuetable-pagination ref="pagination" @vuetable-pagination:change-page="onChangePage"></vuetable-pagination>
      </div> -->
    </b-modal>
  </div>
</template>

<script>
import { Bus } from "@/main";
import collect from "collect.js";
import Vue from "vue";
import Vuetable from "vuetable-2/src/components/Vuetable";
import VuetablePagination from "vuetable-2/src/components/VuetablePagination";
import VuetablePaginationInfo from "vuetable-2/src/components/VuetablePaginationInfo";

export default {
  props: {
    size: {
      default: 0,
    },
  },
  components: {
    Vuetable,
    VuetablePagination,
    VuetablePaginationInfo,
  },
  data() {
    return {
      tags: "",
      hideFooter: true,
      file: "",
      gallery: "",
      httpOptions: {
        baseURL: this.$http.defaults.baseURL,
        headers: this.$http.defaults.headers.common,
      },
      perPage: 20,
      page: 1,
      nrOfRows: 0,
      moreParams: {},
      filterText: "",
      fields: [
        {
          name: "__sequence", // <----
          title: "#",
          titleClass: "center aligned",
          dataClass: "right aligned",
        },
        {
          name: "name",
          title: "Name",
          titleClass: "text-center",
          sortField: "name",
        },
        {
          name: "__slot:src",
          title: "Image",
          titleClass: "text-center",
        },
        {
          name: "__slot:created_at",
          title: "Created",
          sortField: "created_at",
        },
        {
          name: "size",
          title: "Size(kb)",
          titleClass: "text-center",
          sortField: "size",
        },
        {
          name: "__slot:actions",
          title: "Actions",
          titleClass: "text-center",
          dataClass: "text-center",
        },
      ],
      sortOrder: [
        {
          field: "created_at",
          direction: "desc",
        },
      ],
    };
  },
  methods: {
    loadMediaGallery() {
      this.$http.get(`${this.$api_url}/scandir`).then((data) => {
        if (data) {
          const dir = data.data.dir;
          this.gallery = data.data.dirTree[dir];
        }
      });
    },
    deleteImage(name) {
      //  delete this image
      if (confirm("Are you sure?")) {
        this.$http
          .post(`${this.$api_url}/mediagallery/remove/media/${name}`)
          .then(() => {
            const loadMediaGalleryTimeout = setTimeout(() => {
              this.loadMediaGallery();
              clearTimeout(loadMediaGalleryTimeout);
            }, 500);
          });
      }
    },
    generatePath(fName) {
      return `${this.$api_url}/../media/${fName}`;
    },
    handleFileUpload() {
      this.file = this.$refs.file.files[0];
    },
    selectImage(name) {
      Bus.$emit("imageSelected", name);
    },
    uploadImage() {
      /*
        Initialize the form data
      */
      const formData = new FormData();

      /*
        Add the form data we need to submit
      */
      formData.append("file", this.file);
      formData.append("tags", this.tags);

      /*
        Make the request to the POST /single-file URL
      */
      this.$http
        .post(`${this.$api_url}/mediagallery/upload`, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then(function (data) {
          console.log("Success!");

          const loadMediaGalleryTimeout = setTimeout(() => {
            this.loadMediaGallery();
            clearTimeout(loadMediaGalleryTimeout);
            this.file = "";
          }, 500);
        })
        .catch(function () {
          console.log("FAILURE!!");
        });
    },
    doFilter() {
      this.moreParams = {
        filter: this.filterText,
      };

      Vue.nextTick(() => this.$refs.vuetable.refresh());
    },
    resetFilter() {
      this.filterText = "";
      this.moreParams = {};
      // Vue.nextTick(() => this.$refs.vuetable.refresh())
    },
    onPaginationData(paginationData) {
      this.$refs.pagination.setPaginationData(paginationData);
      this.$refs.paginationInfo.setPaginationData(paginationData); // <----
    },
    onChangePage(page) {
      this.$refs.vuetable.changePage(page);
    },
    reloadTable() {
      this.$refs.vuetable.refresh();
    },
    formatDate(value, fmt = "D MMM YYYY") {
      return value === null ? "" : this.$moment(value).format(fmt);
    },
  },
  computed: {
    filteredData() {
      // Filter by name, width or height if filterText is not empty
      let filtered = collect(this.gallery ?? []).filter((item) => {
        const searchText = this.filterText?.toLowerCase();

        if (this.size == 0 && searchText == "") {
          return true;
        }

        if (this.searchText == "" && this.size != 0) {
          return item?.width >= parseInt(this.size?.split("x")?.[0]);
        }

        if (this.searchText != "" && this.size != 0) {
          return (
            item?.name?.toLowerCase()?.includes(searchText) ||
            item?.width?.toString()?.includes(searchText) ||
            `${item.width}x${item.height}`.includes(searchText) ||
            item?.tags?.toString()?.toLowerCase()?.includes(searchText) ||
            item?.height?.toString()?.includes(searchText) ||
            item.width >= parseInt(this.size?.split("x")?.[0])
          );
        } else {
          return (
            item?.name?.toLowerCase()?.includes(searchText) ||
            item?.width?.toString()?.includes(searchText) ||
            `${item.width}x${item.height}`.includes(searchText) ||
            item?.tags?.toString()?.toLowerCase()?.includes(searchText) ||
            item?.height?.toString()?.includes(searchText)
          );
        }
      });

      this.nrOfRows = filtered.count();

      // Calculate the start and end index of the current page
      const start = (this.page - 1) * this.perPage;
      const end = start + this.perPage;

      // Return the items for the current page, if there are any
      if (this.nrOfRows <= start) {
        return [];
      } else {
        return filtered.all().slice(start, Math.min(this.nrOfRows, end));
      }
    },
    validImages() {
      const images = collect(this.gallery);
      return images
        .filter((g) => {
          return g.name !== ".gitignore";
        })
        .all();
    },
  },
  created() {
    this.loadMediaGallery();
  },
};
</script>
<style scoped>
/deep/ #media-gallery .modal-dialog {
  max-width: 100%;
}
</style>
